export default "__VITE_ASSET__DLPDdfPw__"